import { render, staticRenderFns } from "./configurationValue.vue?vue&type=template&id=50c2ade4"
import script from "./configurationValue.vue?vue&type=script&lang=ts"
export * from "./configurationValue.vue?vue&type=script&lang=ts"
import style0 from "./configurationValue.vue?vue&type=style&index=0&id=50c2ade4&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c2ade4')) {
      api.createRecord('50c2ade4', component.options)
    } else {
      api.reload('50c2ade4', component.options)
    }
    module.hot.accept("./configurationValue.vue?vue&type=template&id=50c2ade4", function () {
      api.rerender('50c2ade4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configuration/configurationValue.vue"
export default component.exports